import React from 'react';

export const ProductCardSkeleton = () => {
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <div className="w-full h-64 skeleton"></div>
      <div className="p-4">
        <div className="h-4 skeleton mb-2"></div>
        <div className="h-4 skeleton w-3/4 mb-4"></div>
        <div className="h-8 skeleton"></div>
      </div>
    </div>
  );
};

export const ProductDetailSkeleton = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="skeleton h-96"></div>
        <div className="space-y-4">
          <div className="h-8 skeleton"></div>
          <div className="h-4 skeleton w-3/4"></div>
          <div className="h-6 skeleton w-1/2"></div>
          <div className="h-32 skeleton"></div>
        </div>
      </div>
    </div>
  );
};

